
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"20","height":"20","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M10.001 16.902a.695.695 0 00.695-.694V8.832l1.359 1.36a.695.695 0 00.982-.983l-2.544-2.544a.694.694 0 00-.105-.087l-.034-.018a.683.683 0 00-.085-.046l-.05-.016a.688.688 0 00-.355-.024.682.682 0 00-.083.026l-.046.014a.687.687 0 00-.083.044l-.036.02a.697.697 0 00-.101.083L6.965 9.21a.698.698 0 10.982.992L9.31 8.84v7.368a.695.695 0 00.692.695z","fill":"#9D4B72"}}),_c('path',{attrs:{"d":"M3.554 13.791H7.17a.694.694 0 100-1.389H3.554a.496.496 0 01-.496-.496v-7.52a.496.496 0 01.496-.497h12.898a.496.496 0 01.496.496v7.52a.496.496 0 01-.496.497h-3.621a.694.694 0 100 1.389h3.617a1.887 1.887 0 001.885-1.885v-7.52A1.887 1.887 0 0016.448 2.5H3.55a1.887 1.887 0 00-1.883 1.885v7.52a1.887 1.887 0 001.887 1.886z","fill":"#9D4B72"}})])
          )
        }
      }
    